import { render, staticRenderFns } from "./SidebarWidget.vue?vue&type=template&id=390b13fa&"
import script from "./SidebarWidget.vue?vue&type=script&lang=js&"
export * from "./SidebarWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports